var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFileDrag),expression:"isFileDrag"}],ref:"dropzone",staticClass:"dropzone"},[_c('div',{staticClass:"dropzone__area"},[_c('span',{staticClass:"text-xxl"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }